export default __webpack_public_path__ + "static/e-commerce-771eb53bcd2280722aecc7c257f577ea.png";